var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInsuranceHandOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6313 4.66977C23.94 4.66977 23.3797 5.23006 23.3797 5.92137V9.44097H19.8601C19.1691 9.44097 18.6088 10.0013 18.6088 10.6926V14.7596C18.6088 15.4507 19.1691 16.011 19.8601 16.011H23.3797V19.5306C23.3797 20.2219 23.94 20.7822 24.6313 20.7822H28.6984C29.3897 20.7822 29.9498 20.2219 29.9498 19.5306V16.011H33.4696C34.1607 16.011 34.721 15.4507 34.721 14.7596V10.6926C34.721 10.0013 34.1607 9.44097 33.4696 9.44097H29.9498V5.92137C29.9498 5.23006 29.3897 4.66977 28.6984 4.66977H24.6313Z",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.27917 29.0728L11.3955 34.1698C12.2952 34.9193 13.4291 35.3303 14.6002 35.3303H30.7252C31.8769 35.3303 32.8107 34.3963 32.8107 33.2443C32.8107 30.9405 30.9432 29.0728 28.6394 29.0728H17.4289",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7878 26.5701L14.6649 28.447C15.7017 29.4839 17.3825 29.4839 18.4192 28.447C19.456 27.4103 19.456 25.7296 18.4192 24.6929L15.5054 21.779C14.5666 20.8402 13.2935 20.3128 11.9657 20.3128H5.27917",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInsuranceHandOutline);
export default __webpack_public_path__ + "static/media/icon_insurance_hand_outline.4bd53519c2df95d3b4621a17fe79c33a.svg";
export { ForwardRef as ReactComponent };